<template>
  <div class="animated fadeIn h-100">
      <div class="c-dashboard">
        <calendar-view
          :items="items"
          :show-date="showDate"
          :time-format-options="{ hour: 'numeric', minute: '2-digit' }"
          :show-times="false"
          :starting-day-of-week="0"
          :class="themeClasses"
          :displayWeekNumbers="true"
          @click-date="onClickDay"
          @click-item="onClickItem"
        >
          <template #header="{ headerProps }">
            <calendar-view-header #header :header-props="headerProps" @input="setShowDate"/>
          </template>
          <template #weekNumber="{date }">
            <span>{{ weekNumber(date) }}</span>
          </template>
        </calendar-view>
      </div>

    <b-modal size="md" id="item-selection-modal" ref="item-selection-modal" :title="modalTitle">

      <b-alert variant="success" show v-if="selected && selected.holiday">
        <h4 class="alert-heading">{{ selected.holiday.name }}</h4>
        <p>Alle leverdagen worden verplaatst naar <b>{{ selected.holiday.replacement_date }}</b></p>
        <hr />
        <p class="mb-0">
          <router-link :to="{ name: 'holidays.view', params: { id: selected.holiday.id }}">Bekijk feestdag</router-link>
        </p>
      </b-alert>

      <table class="table" v-if="selected">
        <thead>
        <tr>
          <th>&nbsp;</th>
          <th>Op afroep</th>
          <th>Regulier</th>
        </tr>
        </thead>
        <tr>
          <th>Klanten met transportdag</th>
          <td>{{ selected.on_demand_slots }}</td>
          <td>{{ selected.on_schedule_slots }}</td>
        </tr>
        <tr>
          <th>Aantal stops</th>
          <td>{{ selected.on_demand_transports }}</td>
          <td>{{ selected.on_schedule_transports }}</td>
        </tr>
      </table>
      <template #modal-footer>
        <b-button class="ml-0" @click.prevent="hideSelectionModal">Annuleren</b-button>
        <b-button type="submit" class="ml-auto" variant="danger" v-can="'transportdagen aanpassen'" v-b-modal.confirm-deletion-modal>Afroepklanten blokkeren</b-button>
      </template>
    </b-modal>

    <b-modal id="confirm-deletion-modal" ref="confirm-deletion-modal" title="Keuze bevestigen" v-if="selected">
      <p class="my-2">Weet je zeker dat je nieuwe leveringen voor afroep klanten op <b>{{ modalTitle }}</b> wilt blokkeren?</p>
      <template #modal-footer>
        <b-button type="submit" class="ml-auto" block variant="danger" @click.prevent="deleteDemandSlots">Ja, blokkeer leveringen</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>

import moment from "moment";
import {CalendarMathMixin, CalendarView, CalendarViewHeader,} from "vue-simple-calendar"
import {getData, deleteItem} from '../../api';

require("vue-simple-calendar/static/css/default.css")

export default {
  name: "Dashboard",
  components: {
    CalendarView,
    CalendarViewHeader,
  },
  mixins: [CalendarMathMixin],
  data() {
    return {
      showDate: this.thisMonth(1),
      data: [],
      selected: undefined,
    }
  },
  computed: {
    items() {
      return this.data.map(d => d.items).flat();
    },

    themeClasses() {
      return {
        "theme-default": true,
      }
    },

    modalTitle() {
      if(!this.selected){
        return null;
      }

      return moment(this.selected.id).format('dddd LL');
    }
  },
  async mounted() {
    await this.fetchItems();
  },
  methods: {
    openSelectionModal() {
      this.$refs['item-selection-modal'].show()
    },
    hideSelectionModal() {
      this.$refs['item-selection-modal'].hide();
    },
    async deleteDemandSlots() {
      this.$refs['confirm-deletion-modal'].hide();
      this.hideSelectionModal();

      await deleteItem(`dashboard/${this.selected.id}`);
      await this.fetchItems();
    },
    thisMonth(d, h, m) {
      const t = new Date()
      return new Date(t.getFullYear(), t.getMonth(), d, h || 0, m || 0)
    },
    onClickDay(d) {
      const key = moment(d).format('Y-MM-DD');
      const item = this.data.find(i => i.id === key);

      if(!item){
        return;
      }

      this.selected = item;
      this.openSelectionModal();
    },
    onClickItem(i) {
      this.onClickDay(i.originalItem.startDate);
    },
    async setShowDate(d) {
      this.showDate = d
      await this.fetchItems();
    },
    async fetchItems() {
      await getData(`dashboard/${moment(this.showDate).format('Y-M-DD')}`)
        .then(({data}) => this.data = data.data);
    },
    weekNumber(date){
      return moment(date)
        .add(1, 'day')
        .isoWeek();
    }
  },
}
</script>
